import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class ConfettiView extends AbstractView {

    constructor(target) {
        super(target);

        this._layers = [];
        for (let i = 0; i < 99; i++) {
            const layer = this._target["confetti" + (i + 1)];
            if (!layer) {
                break;
            }
            layer.yOrig = layer.y;
            layer.xOrig = layer.x;
            this._layers.push(layer);
        }
        this.show(false);
    }

    show(bool) {
        this._target.visible = bool;
    }

    animate(dy, duration) {
        this.show(true);
        this._layers.forEach((layer, idx) => {
            layer.x = layer.xOrig;
            layer.y = layer.yOrig;
            const params = {};
            if (idx==0) {
                params.onComplete = () => { this.show(false); };
            }
            createjs.Tween.get(layer, params).to({y: layer.y + dy * Math.pow(PARALLAX_FACTOR, idx)}, duration);
        });
    }

}

const PARALLAX_FACTOR = .9;